// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-0e2b0ea3] {\n  --magic-border-radius: 12px;\n  --magic-caption: var(--magic-tertiary, #311261);\n  --button-hollow-border-color: #fd0;\n  --button-hollow-background: #fd0;\n  --button-hollow-border-hover-color: #e5c700;\n  --button-hollow-color: var(--magic-tertiary, #311261);\n  color: var(--magic-tertiary, #311261);\n}", ""]);
// Exports
module.exports = exports;
